import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './cookiebeleid.component.html',
    standalone: false
})
export class CookiebeleidComponent implements OnInit, OnDestroy {
    @ViewChild('cookieLijst', { static: true }) private cookieLijst: ElementRef<HTMLElement>;

    private cookieListObserver: MutationObserver;

    constructor(
        private renderer2: Renderer2,
        public translate: TranslateService
    ) { }

    public ngOnInit(): void {
        this.cookieListObserver = new MutationObserver(() => {
            const container = this.cookieLijst.nativeElement.querySelector<HTMLElement>('#cky-policy-container');
            if (container) {
                this.strip(container);
            }
        });
        this.cookieListObserver.observe(this.cookieLijst.nativeElement, { childList: true, subtree: true });

        const script = this.renderer2.createElement('script');
        script.type = 'text/javascript';
        script.id = 'cky-cookie-policy';
        script.src = `https://cdn-cookieyes.com/client_data/${environment.cookieyesId}/cookie-policy/script.js`;

        this.renderer2.appendChild(this.cookieLijst.nativeElement, script);
    }

    public ngOnDestroy(): void {
        this.cookieListObserver?.disconnect();
    }

    // Strip the CookieYes policy down to the list of cookies; the surrounding text is in our own translations
    private strip(container: HTMLElement): void {
        Array.from(container.children).forEach((child) => {
            if (!child.classList.contains('cky-audit-table-element')) {
                this.renderer2.removeChild(container, child);
            }
        });

        Array.from(container.childNodes).forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
                this.renderer2.removeChild(container, child);
            }
        });
    }

    public getTranslatedBody(key: string): Observable<string> {
        return this.translate.get(key).pipe(
            switchMap(value => {
                if (Array.isArray(value)) {
                    return of(value.join('\n'));
                }
                return of(value);
            })
        );
    }
}
